import type { TableColumnsType } from 'ant-design-vue'

// 场景分类列
export const columns: TableColumnsType = [
  {
    title: '分类code',
    key: 'scenarioCode',
    dataIndex: 'scenarioCode',
    width: 130,
  },
  {
    title: '场景分类',
    key: 'scenarioName',
    dataIndex: 'scenarioName',
  },
]

// 场景管理列
export const configColumns: TableColumnsType = [
  {
    title: '场景code',
    key: 'subScenarioCode',
    dataIndex: 'subScenarioCode',
  },
  {
    title: '子场景名称',
    key: 'subScenarioName',
    dataIndex: 'subScenarioName',
  },
  {
    title: '所属分类',
    key: 'scenarioName',
    dataIndex: 'scenarioName',
  },
  // {
  //   title: '备注',
  //   key: 'remark',
  //   dataIndex: 'remark',
  // },
  // {
  //   title: '操作',
  //   key: 'handle',
  //   dataIndex: 'handle',
  //   align: 'right',
  // },
]

// 渠道 Mock 配置列（对应设计稿：支付渠道 | 三方订单号字段 | mock成功报文 | mock失败报文 | 操作）
// 宽度策略：前两列定宽不折行（渠道名最长如「支付宝电脑网站支付」），两个报文列平分剩余空间，操作列定宽
export const channelMockColumns: TableColumnsType = [
  {
    title: '支付渠道',
    key: 'payChnl',
    dataIndex: 'payChnl',
    width: 200,
  },
  {
    title: '三方订单号字段',
    key: 'orderNoField',
    dataIndex: 'orderNoField',
    width: 170,
  },
  {
    title: 'mock成功报文',
    key: 'mockSuccessBody',
    dataIndex: 'mockSuccessBody',
    // 不设宽度，与失败报文列平分剩余空间
  },
  {
    title: 'mock失败报文',
    key: 'mockFailBody',
    dataIndex: 'mockFailBody',
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    width: 120,
    align: 'center',
  },
]

// 场景映射列
export const scenarioMap: Record<string, string> = {
  preOrder: '预下单',
  clientPay: '客户端支付',
  verifyOrder: '验单',
  pendingOrder: '补单',
  refund: '退款',
}
